<template>
  <div class="order-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" />
    <MilkOrderListComponent
      v-if="pageData"
      :page-data="pageData"
      @view="view"
      @close="close"
      @remove="remove"
      @edit="edit"
      @onSelectChanged="onSelectChanged"
      @onPageChanged="onPageChanged" />
    <el-dialog :title="orderDialog.canEdit ? '修改订单' : '订单详情'" :visible.sync="orderDialog.showEditDialog" width="70%" @closed="hideOrderEditDialog" :close-on-click-modal="false">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">订购信息</span>
          </div>
          <div class="text item">
              <el-table :data="orderData.buyer" border style="width: 100%; margin-bottom: 20px">
                <el-table-column align="center" prop="nickname" label="会员昵称"/>
                <el-table-column align="center" prop="name" label="姓名" width="150"/>
                <el-table-column align="center" prop="phone" label="手机号" width="150" />
                <el-table-column align="center" prop="address" label="收货地址" min-width="300" />
              </el-table>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">商品信息</span>
          </div>
          <div class="text item">
            <el-table :data="orderData.detail" border style="width: 100%; margin-bottom: 20px">
              <el-table-column align="center" label="商品信息">
                <template slot-scope="scope">
                  <el-image style="width: 50px; height: 50px;float: left" :src="scope.row.goods_image" fit="cover" />
                  <span style="float:left;height: 50px;line-height: 50px;margin-left: 5px;">{{scope.row.goods_title}}</span>
                </template>
              </el-table-column>
<!--              <el-table-column align="center" label="单价" width="150">-->
<!--                <template slot-scope="scope">￥{{scope.row.price}}</template>-->
<!--              </el-table-column>-->
              <el-table-column align="center" label="数量" width="150">
                <template slot-scope="scope">
                  <span v-if="!orderDialog.canEdit">￥{{scope.row.quantity}}</span>
                  <el-input v-if="orderDialog.canEdit && !scope.row.removed" type="text" v-model="scope.row.quantity" @input="checkQuantity(scope.row)">
                    <el-button slot="append" v-if="scope.row.modified" @click="saveGoodsNumber(scope.row)">保存</el-button>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="orderDialog.canEdit" align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <span class="action" v-if="!scope.row.removed" @click="removeGoods(scope.row)">删除</span>
                  <span class="action" v-if="scope.row.removed">已删除</span>
                </template>
              </el-table-column>
<!--              <el-table-column align="center" label="小计" width="150">-->
<!--                <template slot-scope="scope">￥{{scope.row.amount}}</template>-->
<!--              </el-table-column>-->
            </el-table>
          </div>
        </el-card>
      <el-card class="box-card" v-if="false">
        <div slot="header" class="clearfix">
          <span class="title">下单/支付信息</span>
        </div>
        <div class="text item">
            <el-table :data="orderData.showPayment" border style="width: 100%; margin-bottom: 20px">
              <el-table-column align="center" prop="order_no" label="订单号" width="150"/>
              <el-table-column align="center" prop="total_amount" label="订单金额" width="120"/>
              <el-table-column align="center" prop="status" label="支付状态" width="120"/>
              <el-table-column align="center" prop="pay_time" label="支付时间" width="160"/>
              <el-table-column align="center" prop="pay_amount" label="支付金额" width="120"/>
              <el-table-column align="center" prop="channel" label="支付方式"/>
              <el-table-column align="center" prop="third_order_no" label="支付交易号" width="200" />
            </el-table>
        </div>
      </el-card>
      <el-card class="box-card" v-if="orderData.logs && orderData.logs.length > 0">
        <div slot="header" class="clearfix">
          <span class="title">订单日志</span>
        </div>
        <div class="text item">
          <el-table :data="orderData.logs" border style="width: 100%; margin-bottom: 20px">
            <el-table-column align="center" prop="actionText" label="类型"/>
            <el-table-column align="center" prop="ctime" label="时间"/>
            <el-table-column align="left" header-align="center" label="内容">
              <template slot-scope="scope">
                <span v-if="scope.row.extend">
                  商品ID：{{scope.row.extend.goods_id}}<br/>
                  商品名称：{{scope.row.extend.goods_title}}<br/>
                  修改后数量：{{scope.row.extend.description}}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作人">
              <template slot-scope="scope">
                {{scope.row.user ? scope.user.name : '管理员'}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDialog.showEditDialog = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import {MessageUtil} from '../../../utils/MessageUtil'
import MilkOrderListComponent from '../../../components/order/MilkOrderListComponent'

export default {
  name: 'MilkOrderListPage',
  components: {
    MilkOrderListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateOrderList()
  },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateOrderList },
        { title: '导出订单', icon: 'el-icon-download', type: 'button', theme: 'primary', action: this.exportOrderList },
        { title: '导出采购单', icon: 'el-icon-download', type: 'button', theme: 'primary', action: this.exportOrderGoodsList },
        { title: '订单状态',
          type: 'selectx',
          action: this.onAuditStateChange,
          options: [
            {title: '全部', value: 0},
            {title: '待付款', value: 1},
            {title: '已付款', value: 2},
            {title: '已关闭', value: 3}
          ]},
        {title: '订单时间',
          type: 'datePicker',
          action: this.onDatePickerChange,
          value: '',
          pickOptions: {
            shortcuts: [{
              text: '最近一周',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }]
          }}
      ],
      areas: {
        lazy: true,
        lazyLoad (node, resolve) {
          MilkRequestUtil.queryArea({parentId: node.value}, (items) => {
            const nodes = items.map(item => ({
              value: item.id,
              label: item.name,
              leaf: item.has_children !== '1'
            }))
            resolve(nodes)
          })
        }
      },
      filters: [
        {
          searchValue: '',
          type: 'order_no',
          title: '订单编号',
          options: [
            {title: '订单编号', value: 'order_no'},
            {title: '片区', value: 'area'},
            {title: '单位', value: 'department'},
            {title: '收货人', value: 'receiver'},
            {title: '收货人手机号', value: 'phone'}
          ],
          action: this.onFilterChange
        }
      ],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        status: null,
        keywords: null,
        overview: false,
        startDate: '',
        endDate: ''
      },
      orderData: {
        province: '',
        city: '',
        county: '',
        detail: [],
        buyer: [],
        payment: {},
        showPayment: [],
        logs: []
      },
      orderDialog: {
        showEditDialog: false,
        canEdit: true,
        prevImages: []
      }
    }
  },
  methods: {
    showOrderEditDialog (item, canEdit) {
      let orderData = JSON.parse(JSON.stringify(item))
      orderData.logs = []
      this.orderDialog.canEdit = canEdit || false
      if (orderData.id) {
        this.orderData = orderData
        this.orderData.buyer = [{
          nickname: orderData.user.nickname,
          name: orderData.receiver,
          phone: orderData.receiver_phone,
          address: orderData.receiver_address
        }]
        let payment = orderData.payment
        if (payment) {
          this.orderData.showPayment = [{
            order_no: payment.order_no,
            total_amount: '￥' + orderData.total_amount,
            status: payment.statusText,
            pay_time: payment.pay_time || '-',
            pay_amount: (payment.pay_amount ? '￥' + payment.pay_amount : '-'),
            channel: payment.channelText || '-',
            third_order_no: payment.third_order_no || '-'
          }]
        }
        // 查询订单日志
        let that = this
        MilkRequestUtil.queryOrderLog({orderNo: orderData.order_no}, (response) => {
          that.orderData.logs = response
        })
      }
      this.orderDialog.showEditDialog = true
    },
    hideOrderEditDialog () {
      this.orderData = {}
      this.orderDialog.showEditDialog = false
    },
    updateOrderList () {
      let that = this
      this.pageData = {}
      MilkRequestUtil.queryOrderList({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    exportOrderList () {
      this.queryParam.overview = false
      window.open('/mgr/milk/order/export?params=' + encodeURIComponent(JSON.stringify(this.queryParam)), '_blank')
    },
    exportOrderGoodsList () {
      this.queryParam.overview = true
      window.open('/mgr/milk/order/export?params=' + encodeURIComponent(JSON.stringify(this.queryParam)), '_blank')
    },
    onAuditStateChange (item) {
      this.queryParam.page = 1
      this.queryParam.status = parseInt(item.selectValue)
      this.updateOrderList()
    },
    onDatePickerChange (item) {
      this.queryParam.startDate = item.value[0]
      this.queryParam.endDate = item.value[1]
      this.updateOrderList()
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateOrderList()
    },
    checkQuantity (value) {
      value.modified = true
      if (parseInt(value.quantity) > 999) {
        value.quantity = '999'
      }
    },
    saveGoodsNumber (value) {
      let that = this
      MilkRequestUtil.updateOrderGoods({id: value.id, quantity: value.quantity}, (response) => {
        if (response.result) {
          value.modified = false
          value.quantity = parseInt(value.quantity)
          console.log(value)
          that.updateOrderList()
        }
      })
    },
    view (param) {
      this.showOrderEditDialog(param, false)
    },
    edit (param) {
      this.showOrderEditDialog(param, true)
    },
    close (param) {
      MessageUtil.tipsConfirm('确认关闭此交易？', 'warning', () => { MilkRequestUtil.closeOrder(param, this.updateOrderList) })
    },
    remove (param) {
      MessageUtil.tipsConfirm('确认删除此交易？', 'warning', () => { MilkRequestUtil.removeOrder(param, this.updateOrderList) })
    },
    removeGoods (value) {
      let that = this
      MessageUtil.tipsConfirm('确认删除此商品？', 'warning', () => {
        MilkRequestUtil.removeOrderGoods({id: value.id}, (response) => {
          if (response.result) {
            value.removed = true
            value.quantity = parseInt(value.quantity)
            that.updateOrderList()
          }
        })
      })
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateOrderList()
    }
  }
}
</script>

<style scoped lang="less">

.box-card {
  margin-bottom: 10px;

  .title {
    font-weight: bold;
  }

  .area-picker{
    width: 100%;
  }
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/milk/order/MilkOrderListPage.vue